import { PageWebhooksEdit } from './Edit';
import { PageWebhooks } from './Overview';

export const WEBHOOKS = {
  Webhooks: PageWebhooks,
  WebhooksEdit: PageWebhooksEdit,
} as const;
